import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRandomMediaWithPeak, getRandomPlace } from 'services/api/media';
import { releaseRandomPlace, takeRandomPlace } from 'utils/boot';

// The start page: the view of a random place (places of more photos more often), else a random
// photo, else the map.
const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // where it's going next: ready by the time the place is drawn
    import('components/Place').catch(() => { /* loaded again on the way there */ });
    // run twice in development (StrictMode): only the last run goes on
    let cancelled = false;
    const go = (to: string) => {
      if (cancelled) return;
      releaseRandomPlace();
      navigate(to, { replace: true });
    };
    (async () => {
      try {
        // the start script has usually drawn it already, and is showing its photo
        const place = await takeRandomPlace() ?? await getRandomPlace();
        go(`/place/${place.mediaId}`);
        return;
      } catch (error) {
        console.error('Error fetching random place:', error);
      }
      try {
        const media = await getRandomMediaWithPeak();
        // /place itself goes on to the photo when it has no tags
        go(`/place/${media.mediaId}`);
      } catch (error) {
        console.error('Error fetching random picture:', error);
        go('/map');
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      color: '#fff',
    }}>
      Ładowanie…
    </div>
  );
};

export default Landing;
